import Page from "./page";
import { useTranslation } from "react-i18next";
import qrcode from '../../assets/software/qrcodeOrange.png';
import Pic1 from '../../assets/software/shop/1.png';
import Pic2 from '../../assets/software/shop/2.png';
import logo1 from '../../assets/software/shop/logo1.png';
import logo2 from '../../assets/software/shop/logo2.png';
import shopPic from '../../assets/software/shop/shop.png';
import u1 from "../../assets/software/u1.png";
import u2 from "../../assets/software/u2.png";
import u3 from "../../assets/software/shop/u3.png";
import u4 from "../../assets/software/shop/u4.png";
function Shop() {
  let { t } = useTranslation();

  const datas = [
    {
      pic: Pic1,
      logo: logo1,
      title: t("shopType.reportTitle"),
      infos: [
        t("shopType.reportInfo1"),
        t("shopType.reportInfo2"),
        t("shopType.reportInfo3"),
        t("shopType.reportInfo4"),
      ],
      bgcolor: "rgb(255,248,240)",
    },
    {
      pic: Pic2,
      logo: logo2,
      title: t("shopType.goodsTitle"),
      infos: [
        t("shopType.goodsInfo1"),
        t("shopType.goodsInfo2"),
        t("shopType.goodsInfo3"),
      ],
    }
  ]
  return (
    <Page
      {...{
        title: t("shopType.title"),
        content: t("shopType.info"),
        pic: shopPic,
        bgColor: "rgba(255, 142, 43, 1)",
        linearGradient: 'linear-gradient(161.37deg, rgba(255, 106, 0, 1) 0%, rgba(255, 153, 64, 1) 100%)',
        downInfo: {
          bgColor: "#ff8122",
          qrBgColor: '#ffebd1',
          qrcode: qrcode,
          showWin: false,
          urlName: 'toposify_marchand',
          url1: "https://play.google.com/store/apps/details?id=com.huitongshidai.toposify_marchand_app",
          url2: "https://itunes.apple.com/app/6742176630",
          u1: u1,
          u2: u2,
          u3: u3,
          u4: u4,
          showWin: false
        },
        bodyDatas: datas,
        textColor: '#fff'
      }}
    />
  );
}

export default Shop;

